<span class="icon is-{size} has-text-{type}" title="{title}">
  <i class="fas {iconSize} fa-{icon}"></i>
</span>

<script>
// https://bulma.io/documentation/elements/icon/#colors
export let type = "success";
export let icon = "check-square";
export let size = "default"; // small, default, medium, large
export let iconSize = "fa-lg"; // lg x2 x3
export let title = "";
</script>
